module.exports = __webpack_public_path__ + "img/bsaicIcon.c8aa63f0.svg";